module.exports = __webpack_public_path__ + "806d113121d7cf8145e200329a723cec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/8.jpg
// module id = 232
// module chunks = 0